import * as types from '../types'
import * as assetApi from '../../api/core/assets.dd'
import { setPriority } from 'os';
import { allResolved } from 'q';
import { store } from '../store';
import Vue from 'vue'

const state = {
    aggregateModes:[
        {key:"min",label:"Minimum"}, 
        {key:"max",label:"Maximum"}, 
        {key:"avg",label:"Gemiddeld"}
    ],
    markerShapes:[      
        {key:"", label:"Standaard vorm"},
        {key:"circle", label:"Circel"},
        {key:"square", label:"Vierkant"},
        {key:"triangle", label:"Driehoek (zonder Icon)"}
    ],
    measurementUnits:[
        {key:"percentage",label:"Percentage (%)"}, 
        {key:"celcius",label:"Graden celsius (°C)"}, 
        {key:"mps",label:"Meters per seconde (m/s)"},
        {key:"kph",label:"Kilometers per uur (km/u)"}
    ],
    calculationUnits:[
      {key:"",  label:"Geen"},
      {key:"/", label:"Delen door"},
      {key:"*", label:"Vermeningvuldigen met"},
      {key:"+", label:"Optellen met"},
      {key:"-", label:"Aftrekken met"},
    ],
    customFieldTypes:[
      {internal_name:"select", label:"Dropdown", has_allowed_values:true},
      {internal_name:"date", label:"Datum", has_allowed_values:false },
      {internal_name:"datetime", label:"Datum/tijd",has_allowed_values:false},
      {internal_name:"time", label:"Tijd",has_allowed_values:false},
      {internal_name:"checkbox", label:"Checkbox",has_allowed_values:true},
      {internal_name:"text", label:"Tekst",has_allowed_values:false},
      {internal_name:"numeric", label:"Getal",has_allowed_values:false},
      {internal_name:"numeric_range", label:"Getallen reeks",has_allowed_values:true}
    ],
    operatorTypes:[
      {internal_name:">", label:"Is groter dan"},
      {internal_name:"<", label:"Is kleiner dan"},
      {internal_name:"==", label:"Is gelijk aan"},
      {internal_name:">=<=", label:"Valt binnen: waarde1,waarde2"}
    ]        

  }

  const getters = {
    [types.HD_OPERATORS]: (state) => {
      return state.operatorTypes
    },
    [types.HD_AGGREGATE_MODES]: (state) => {
      return state.aggregateModes
    },
    [types.HD_MEASUREMENT_UNITS]: (state) => {
      return state.measurementUnits
    },
    [types.HD_CALCULATION_UNITS]: (state) => {
      return state.calculationUnits
    },
    [types.HD_CUSTOM_FIELD_TYPES]: (state) => {
      return state.customFieldTypes
    },  
    [types.HD_MARKER_SHAPES]: (state) => {
      return state.markerShapes
    }        
  }
  export default {
      state,
      getters
  }

